import React from 'react';
import styled from 'styled-components';
import { Popconfirm, Icon } from 'antd';
import ActionButton from '$app/apps/bookings/components/ActionButton';

const Button = styled(ActionButton)`
  &.ant-btn {
    color: #f00 !important;
  }
`;

export function DeleteButton({ onConfirm, notifyCustomer, isDeleting, txt = 'Delete' }) {
  const title = (
    <span>
      Press 'Yes' to cancel this work operation.
      <br />
      The booking totals will be updated
      <b>
        {notifyCustomer ? ' and the customer will be notified.' : ' but the customer will not be notified.'}
      </b>
    </span>
  );
  return (
    <Popconfirm title={title} placement="topRight" onConfirm={onConfirm} okText="Yes" cancelText="No">
      <Button
        key='delete'
        type='danger'
        onClick={e => e.stopPropagation()}
        className='pull-left'
        loading={isDeleting}
      >{txt} <img alt="delete"
        src="/assets/icons/bin-red.svg"
        width={16}
        style={{
          position: 'relative',
          top: -1,
          marginLeft: 6,
        }}
      /></Button>
    </Popconfirm>
  );
}

export function DeleteIcon() {
  return (
    <img alt="delete"
      src="/assets/icons/bin-1.svg"
      width={17}
      style={{
        position: 'relative',
        top: -2,
      }}
    />
  )
}
